import { subscribe, useSnapshot } from "valtio";
import { bookingsStore, configStore } from "../state/CommonState";
import TaskDatetime from "./task-datetime";
import Taskfileapproval, { validateFileApproval } from "./task-file-approval";
import Taskfiledisplay from "./task-file-display";
import Taskfiletable from "./task-file-table";
import { taskStore } from "./task-store";
import Taskapi from "./tasks-api";
import { useEffect, useState } from "react";
import { OneInput } from "./act-common";
import { AgCustomFile, Agmongofile } from "../components/AgFile";
import MonApi, { CLEAR_BOOKING_POD_LIST_URI, GET_MYACTIONS_LIST_URI, GET_SH_ENTITIES_BY_FILTER_URI } from '../state/mongo-api';
import { DocumentRenderer, DocumentViewerWrapper } from "../mui-components/DocumentViewerWrapper";

export default function PODProcurementaction(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    let task = taskStore.current
    let stage = task.stage

    if (stage >= 1) {
        return (
            <>
                <hr />
                <Taskfiledisplay validation={true} />
            </>
        )
    }
}
export function PODProcurementTrigger(props) {
    useSnapshot(taskStore)
    const [disableButton, setDisableButton] = useState(true)
    const [list,setList] = useState([])
    const [destinations, setDestinations] = useState(bookingsStore.current.contract.multidest.map((e, i) => {
        return {
            name: `Destination ${i + 1} - ${e.destination} `,
            files: [{ label: 'POD', filename: "",approved: '',
                rejectReason: '', ...(bookingsStore.current.fba == 'Yes' && {
                    isnNo: '',
                    isnFilename: ''
                }) }],disable:true
        }
    }))

    useEffect(() => {
        async function getActionData(){
            let data = await MonApi.apost(GET_MYACTIONS_LIST_URI, {
  bookingNum: taskStore.current.bookingNum,
  actionName: taskStore.current.actionName
})
            if(data.length>0){
               data[data.length-1].podProcurement= data[data.length-1].podProcurement.map(item=>{
                        const hasEmpty = item.files.some(file => file.filename == "");
                        return { ...item, disable: hasEmpty };
                    })
                    setDestinations(data[data.length-1].podProcurement)
                    setList(data)
                }
            } 
        getActionData()
       }, [])

    useEffect(() => {
        const hasEmptyFilename = destinations.some((item) => item.files.some(file => file.filename !== ''));            
        setDisableButton(!hasEmptyFilename);
    }, [destinations])
    
    const filecat = '' + Date.now()
    return (
        <>
            {/* <TaskDatetime /> */}
            <hr />
            <div className="p-4 space-y-2">
                {destinations.map((item, index) => (
                    <div key={index}>
                        <p className="font-bold">{item.name}</p><br />
                <table className="table is-striped is-fullwidth is-narrow" style={{ fontSize: '0.8rem' }}>
                        <tr>
                        <th >Document</th>
                        <th >Link</th>
                        {bookingsStore.current.fba == 'Yes' ? <th >ISN No</th> : <></>}
                        {bookingsStore.current.fba == 'Yes' ? <th >ISN Upload</th> : <></>}
                        <th >Actions</th>
                </tr>                

                        {item.files.map((e, i) => (
                        <tr key={i} style={{ padding: '0.5rem' }}>
                                <td className="p-2 border">{e.label}</td>
                                <td className="p-2 border">
                                {e.filename!=='' ?
                                <DocumentViewerWrapper>
                                    <DocumentRenderer render={(updateDocumentState)=>{
                                        return <>
                                        <p>
                                          <a onClick={()=>{
                                              updateDocumentState({documentViewUrl:process.env.REACT_APP_FILE_SERVER + '/api/v1/filestore/getfile/' + taskStore.current.bookingNum + '/' + e.filename,documentTitle:e.filename,open:true})
                                          }} >
                                    {e.filename}
                                        </a>
                                       {item.disable && <span className="icon has-text-danger"  style={{ cursor: 'pointer' }} onClick={() => {
                                            const newFiles = [...item.files];
                                            newFiles[i].filename = '';  
                                            const newData = [...destinations];
                                            newData[index] = { ...item, files: newFiles };
                                            setDestinations(newData);                                       
                                         }}>
                                            <i className="fas fa-trash"></i>
                                        </span>}
                                    </p>
                                        </>
                                    }} />
                                </DocumentViewerWrapper>
                                     :
                                    <Agmongofile parent={e.label.replaceAll(" ","")+"___"+index}
                                    label={e.label} filekey={taskStore.current.bookingNum}
                                    callback={(data,id) => {
                                        const newFiles = [...item.files];
                                        newFiles[i].filename = data.key.filename;  
                                        const newData = [...destinations];
                                        newData[index] = { ...item, files: newFiles };
                                        setDestinations(newData);
                                    }} />
                                }</td>
                                {bookingsStore.current.fba == 'Yes' ? <td> 
                                {item.disable  ? <input onChange={(event)=>{
                                    e.isnNo = event.target.value
                                }}></input>:e.isnNo}
                                </td>:<></>}
                                {bookingsStore.current.fba == 'Yes' ?
                                <td>
                                    {e?.isnFilename ?
                                    <DocumentViewerWrapper>
                                    <DocumentRenderer render={(updateDocumentState)=>{
                                        return <>
                                        <p>
                                          <a onClick={()=>{
                                            updateDocumentState({ documentViewUrl: process.env.REACT_APP_FILE_SERVER + '/api/v1/filestore/getfile/' + taskStore.current.bookingNum + '/' + e.isnFilename, documentTitle: e.isnFilename,open:true})
                                          }} >
                                        {e.isnFilename}
                                        </a>
                                       {item.disable && <span className="icon has-text-danger"  style={{ cursor: 'pointer' }} onClick={() => {
                                            const newFiles = [...item.files];
                                            newFiles[i].isnFilename = '';  
                                            const newData = [...destinations];
                                            newData[index] = { ...item, files: newFiles };
                                            setDestinations(newData);                                       
                                         }}>
                                            <i className="fas fa-trash"></i>
                                        </span>}
                                    </p>
                                        </>
                                    }} />
                                </DocumentViewerWrapper>:
                                    <Agmongofile parent={"ISN".replaceAll(" ", "") + "___" + index}
                                        label={"ISN"} filekey={taskStore.current.bookingNum}
                                        callback={(data, id) => {
                                            const newFiles = [...item.files];
                                            newFiles[i].isnFilename = data.key.filename;
                                            const newData = [...destinations];
                                            newData[index] = { ...item, files: newFiles };
                                            setDestinations(newData);
                                        }} />
                                        }
                                </td>:<></>}
                            <td className="p-2 border">
                                <button
                                disabled={!item.disable}
                                    onClick={() => {
                                        const newFiles = [...item.files];
                                        newFiles.splice(i + 1, 0, {
                                            label: 'POD',
                                            filename: '',
                                            approved: '',
                                        rejectReason: ''
                                        });
                                        const newData = [...destinations];
                                        newData[index] = { ...item, files: newFiles };
                                        setDestinations(newData); 
                                    }}
                                    className="button is-success is-inverted"
                                >
                                    <span className="icon is-small">
                                        <i className="fas fa-plus"></i>
                                    </span>                               
                                 </button>
                                 {item.files.length>1?
                                    <button
                                disabled={!item.disable}
                                    onClick={() => {
                                      const newFiles = [...item.files];
                                      newFiles.splice(i , 1);     
                                      const newData = [...destinations];
                                      newData[index] = { ...item, files: newFiles };
                                      setDestinations(newData);
                                    }}
                                    className="button is-danger is-inverted"
                                 >
                                    <span className="icon is-small">
                                        <i className="fas fa-trash"></i>
                                    </span>
                                 </button>:<></>
                                 }
                                 </td>
                                 </tr>
                            ))}
                        </table>
                    </div>
                ))}
            </div>
            <p>
                <span>
                    <button  style={{ float: 'left' }} className="button islink" disabled={disableButton}
                        onClick={async (e) => {
                            taskStore.current.files = destinations.flatMap(destination => destination.files).filter(file => file.filename.trim() !== "");
                            taskStore.oldtask.files = destinations.flatMap(destination => destination.files).filter(file => file.filename.trim() !== "");
                            taskStore.current.podProcurement = destinations
                            taskStore.oldtask.podProcurement = destinations
                            taskStore.current.stage = 1
                            taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                            taskStore.current.status = 'COMPLETED'
                            taskStore.setComplete()
                            taskStore.setCustomerComplete()
                            const entity = await MonApi.apost(GET_SH_ENTITIES_BY_FILTER_URI, {
  _id: taskStore.current.entityId
})
                            if(entity.length > 0 && entity[0]?.customer?.crossBorder?.salesVertical!='MSME'){
                               const files = taskStore.current.files.map((e)=>e.filename)
                               MonApi.apost(CLEAR_BOOKING_POD_LIST_URI, {
  _id: taskStore.current.bookingNum
})
                            }
                            setDisableButton(true)
                            await Taskapi.saveTask(taskStore.current)
                            taskStore.triggerActionVisible = false
                            taskStore.myActionVisible = false
                        }}>Trigger Action</button>
                </span>
            </p>
        </>
    )
}




















//         <div key={index} >
                    //             <p className="font-bold">{`Destination ${index + 1}`}</p><br />
                    //                 {taskStore.current.files.map((e, i) => (
                    //                     <div key={i} className="flex items-center gap-4">
                    //                         <p>{e.label}</p>
                    //                         {taskStore.current[`Pod ${index + 1}`] ?
                    //                             <p><a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + taskStore.current[`Pod ${index + 1}`]} target="_blank">{taskStore.current[`Pod ${index + 1}`]}</a>
                    //                                 <span className="icon has-text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                    //                                     taskStore.current[`Pod ${index + 1}`] = ""
                    //                                 }}>
                    //                                     <i className="fas fa-trash"></i>
                    //                                 </span>
                    //                             </p> :
                    //                             <AgCustomFile cat={filecat} multi={false} filetype={'Pod'} callback={(filename) => {
                    //                                 e.filename = filename;
                    //                             }} />
                    //                         }
                    //                         <button
                    //                             onClick={() => {
                    //                                 taskStore.current.files.splice(index + 1, 0, {
                    //                                     label: 'pod',
                    //                                     filename: '',
                    //                                 })
                    //                             }}
                    //                             className="mt-2 bg-green-500 px-3 py-1 rounded"
                    //                         >
                    //                             +
                    //                         </button>
                    //                     </div>
                    //                 ))}
                    //                 {/* <span>POD</span>
                    //         {taskStore.current[`Pod ${index + 1}`]?
                    //             <p><a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' +  taskStore.current[`Pod ${index + 1}`]} target="_blank">{ taskStore.current[`Pod ${index + 1}`]}</a>
                    //             <span className="icon has-text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                    //                  taskStore.current[`Pod ${index + 1}`] = ""
                    //             }}>
                    //                 <i className="fas fa-trash"></i>
                    //             </span>
                    //         </p> :
                    //         <AgCustomFile cat={filecat} multi={false} filetype={'Pod'} callback={(filename)=>{
                    //             taskStore.current[`Pod ${index + 1}`] = filename;
                    //         }}/>
                    //         } */}
                    //                 {/* <button
                    //     onClick={()=>{

                    //     }}
                    //     className="mt-2 bg-green-500 text-white px-3 py-1 rounded"
                    // >
                    //     Plus 
                    // </button> */}

                    //         </div>

















                    
